import { render, staticRenderFns } from "./ReferenceData.vue?vue&type=template&id=e10f4c10&scoped=true&"
import script from "./ReferenceData.vue?vue&type=script&lang=js&"
export * from "./ReferenceData.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceData.vue?vue&type=style&index=0&id=e10f4c10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10f4c10",
  null
  
)

export default component.exports